import {mapState} from 'vuex'
import {setRenewStatus} from '@api/order'
import endorsRenewTips from '@/views/components/dialogs/endors-renew-tips'
import {getPolicyDetail} from '@api/policy'
import {getNewSMEQuoteDetail, newSMEPolicyDetail} from '@api/new_sme'
import editKyc from '@/views/tickets/components/edit-refer-case'
import editInternalDoc from '@/views/renew/components/edit-internal-doc'
import {setRenewalTicketStatus} from '@/api/renewal'
import {getQuoteDetail} from '@api/quote'
import SelectSendMessage from '@/views/components/dialogs/select-send-message'
export default {
  components:{
    endorsRenewTips,
    editKyc,
    editInternalDoc,
    SelectSendMessage
  },
  data(){
    return{
      showKyc:false,
      showAutoCloseSelectMessage:false,
      fromEdit: false,
      isViewRenew: false,
      needShowTips: false,
      policyData:{},
      quoteDetailData:{},
      renewalStep:1,
      isFirstLoad:false
    }
  },
  computed:{
    hasEndorsNum(){
      return typeof this.policyData.endorsement_ticket_number == 'string' && this.policyData.endorsement_ticket_number != ''
    },
    renewKycDetail(){
      let data = this.fromEdit?this.quoteDetailData : this.policyData
      let {quote_coverage_list} = this.policyData||{}
      return {...data,...this.policyholderDetail,quote_coverage_list}
    },
    endorsement_ticket_number(){
      let {endorsement_ticket_number} = this.policyData||{}
      return endorsement_ticket_number
    },
    unsettled_claims(){
      let {unsettled_claims} = this.policyData||{}
      return unsettled_claims
    },
    endorsement_order_id(){
      let {endorsement_order_id} = this.policyData||{}
      return endorsement_order_id
    },
    ticketId() {
      let {ticket_id} =this.$route.query||{}
      return ticket_id
    },
    isRenewQuoteStts(){
      let {stts} = this.relation
      return stts ==3
    },
    isBackToQuoted(){
      let {stts} = this.relation||{}
      let {quo_id=0} = this.quote_info||{}
      return stts==5&&quo_id>0
    },
    auto_renew_close_data(){
      let {auto_renew_close_data} = this.relation||{}
      return auto_renew_close_data
    },
    email_auto_renew_close_data(){
      let {renew_email_data={}} = this.relation||{}
      return renew_email_data.auto_renew_close_data||''
    },
    share_auto_renew_close_data(){
      let {share_renew_data={}} = this.relation||{}
      let {share_auto_renew_close_data} = share_renew_data||{}
      return share_auto_renew_close_data||''
    },
  },
  methods: {
    viewRenewQuote(){
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: this.relation.order_id,
          product_id: this.productId
        }
      })
    },
    nextRenewalStep(step){
      this.renewalStep = step
      this.showRenewalTips()
    },
    async  tipsRenewalContinue(isEndorsement=false,type){
      if((this.$refs['endors-tips'].dialog == false) && (this.$refs['claim-tips'].dialog == false) && (this.$refs['renew-tips'].dialog == false)){
        switch(this.renewalStep){
          case  1:
            // add renew quote
            let {endorsement_order_id,renew_order_id}  = this.policyData||{}
            let params = {}
            if(renew_order_id<=0)
              params.is_refresh_user = 1

            if(endorsement_order_id>0&&type==2)
            {
              await this.handler().getProductData({
                hideLoading: true,
                add_renew: 1,
                order_id:endorsement_order_id,
                ...params
              })
            }
            this.showKyc = true
            break
          case 2:
            this.$refs['edit-kyc'].continueAndNext()
            break
          case 3:
            this.$refs['edit-kyc'].$refs['reply'].onReferralSendSms(1)
            break
          case 4:
            this.needShowTips = false
            this.openDialog(this.targetName)
        }
      }
    },
    updateTicketDetail(){
      this.handler().getUpdateDetailData()
    },
    handleUpdateRenewalDetail(){
      let {renew_order_id} = this.policyData||{}
      let params = {}
      if(renew_order_id<=0)
        params.is_refresh_user = 1
      this.mixinHandler().updatePolicyDetail({
        add_renew: 1,
        ...params
      })
    },
    handlerRenewalSave(){
      this.cancelRenewalEdit()
    },
    handleEdit(){
      this.showEdit = true
    },
    handleCancel(){
      this.showEdit = false
    },
    async cancelRenewalEdit() {
      this.showKyc = false
      await this.handler().getUpdateDetailData()
      this.mixinHandler().updatePolicyDetail()
    },
    nextStep(step){
      this.step = step
      this.showRenewalTips()
    },
    showRenewalTips(){
      if(this.hasEndorsNum){
        this.$refs['endors-tips'].changeDialog()
      }
      if(this.unsettled_claims && this.unsettled_claims.length > 0){
        this.$refs['claim-tips'].changeDialog()
      }
    },
    async  editRenewQuote(isView=false){
      this.fromEdit = true
      // 拿quote detail数据回填
      await this.mixinHandler().getQuoteDetail()
      // 调用add_renew检查是否弹窗
      await this.mixinHandler().getProductData({
        hideLoading: true,
        add_renew: 1
      })
      if(!isView&&(this.hasEndorsNum || (this.unsettled_claims && this.unsettled_claims.length > 0))){
        this.showRenewalTips()
        this.renewalStep = 1
        return
      }
      this.isViewRenew = isView
      this.showKyc = true
    },
    async addRenewQuote(){
      this.fromEdit = false
      let newest = this.policyData.record[0]
      let {renew_order_id=0} = this.policyData||{}
      const {period_record, pcy_id} = newest
      const order_id = period_record[0].order_id
      let  params = {}
      if(renew_order_id<=0)
        params.is_refresh_user = 1
      await this.mixinHandler().getProductData({
        hideLoading: true,
        add_renew: 1,
        order_id,
        pcy_id,
        ...params
      })
      if(this.hasEndorsNum || (this.unsettled_claims && this.unsettled_claims.length > 0)){
        this.showRenewalTips()
        this.step = 1
        return
      }
      this.showKyc = true
    },
    handlerRenewSend(data) {
      let params ={}
      let {is_sms_send,content,email_content,share_content,is_share_send,is_email_send} = data ||{}
      params.is_send_sms_auto_renew_close =is_sms_send
      params.is_send_email_auto_renew_close =is_email_send
      params.is_send_share_auto_renew_close =is_share_send
      params.auto_renew_close_content =content
      params.auto_renew_close_email_content =email_content
      params.auto_renew_close_share_content =share_content
      this.changeNoNeedRenewFuc(0,params)
    },
    handlerRenewSkip(content,send_type) {
      let params ={}
      params.is_send_sms =0
      params.is_send_email =0
      params.is_share_send =0
      params.content =''
      params.email_content =''
      params.share_content =''
      this.changeNoNeedRenewFuc(0,params)
    },
    changeNoNeedRenew(type){
      if(type!=1){
        this.showAutoCloseSelectMessage = true
      }else {
        this.changeNoNeedRenewFuc(type)
      }
    },
    changeNoNeedRenewFuc(type,params={}){
      params= {
        ...params
      }
      if(type==1){
        params= {
          back_pending:1
        }
      }
      this.$ConfirmBox({
        isNewConfirm:true,
        width:500,
        title:'Renew Status',
        confirmBtn:'Confirm',
        isGreen:false,
        message: `Are you sure you want to change the renew status to <strong>${type==1?'Quoted':'No Need'}</strong> ?`
      }).then(() => {
        this.mixinNetwork().setRenewalTicketStatus(params)
      })

    },
    mixinHandler(){
      return{
        updatePolicyDetail: (params) => {
          this.mixinHandler().getProductData({
            ...params,
            hideLoading: true
          })
        },
        getProductData: async(params = {}) => {
          let{pre_order_id,pre_pcy_id} = this.relation
          await this.mixinHandler().getPolicyProductDetail({order_id:pre_order_id,pcy_id:pre_pcy_id,...params})
        },
        getPolicyProductDetail: async (result) => {
          if(this.needLoading){
            delete result.hideLoading
          }
          if(this.productId>=80)
          {
            await this.mixinNetwork().newSMEPolicyDetail(result)
            return
          }
          await this.mixinNetwork().getPolicyDetail(result)
        },
        getQuoteDetail:async () =>{
          if(this.productId>=80)
          {
            await this.mixinNetwork().getNewSMEQuoteDetail()
            return
          }
          await this.mixinNetwork().getQuoteDetail()
        }
      }
    },
    mixinNetwork(){
      return{
        setRenewalTicketStatus: async (params) => {
          const {data} = await setRenewalTicketStatus({
            ticket_id: this.ticketId,
            ...params
          })
          this.updateTicketDetail()
        },
        getPolicyDetail: async (params = {}) => {
          const { data } = await getPolicyDetail({
            ...params
          },this.productId)
          this.policyData = data
          this.currentFormData = JSON.parse(JSON.stringify(data))
          this.oldFormDataLock += 1
        },
        newSMEPolicyDetail: async (params = {}) => {
          let {data} = await newSMEPolicyDetail({
            ...params,
          })
          this.policyData = data
          this.currentFormData = JSON.parse(JSON.stringify(data))
          this.oldFormDataLock += 1
        },
        getQuoteDetail: async (params) => {
          const {data} = await getQuoteDetail({
            order_id: this.policyData.renew_order_id,
            ...params
          },this.productId)

          this.quoteDetailData = data
        },
        getNewSMEQuoteDetail: async (params) => {
          const {data} = await getNewSMEQuoteDetail({
            order_id: this.policyData.renew_order_id,
            ...params
          })

          this.quoteDetailData = data
        }
      }
    }
  }
}
